import R from 'ramda';
import moment from 'moment';

export default function AttendanceController($location, $q, $timeout, $scope, $log, $mdToast, $state, $stateParams, GetService, localStorageService, AttendanceService) {

	var self = this;
  $scope.showTableSpinner = true;

  var classRoomName = $stateParams.classRoomName;
  var date = $stateParams.date;
  var classId = $stateParams.cId;

  var classRoomList = localStorageService.get('classrooms');
  if(classRoomList){
    for(var i=0;i<classRoomList.length; i++){
      if(classRoomList[i].classRoomId == classId){
        self.selectedClass = classRoomList[i];
      }
    }
  }

  var showToast = function(){
    $mdToast.show(
      $mdToast.simple()
        .textContent('Records Updated')
        .position('top right')
        .hideDelay(3000)
    );
  };

  $scope.addStudentsMessage = false;
  self.simulateQuery = false;
  $scope.totalItems = [];
  $scope.calFilledDates = [];
  $scope.showAttendanceErr = false;

  self.classRoomList = localStorageService.get('classrooms') || [];

  $scope.day = date || moment().format('YYYY-MM-DD');

  $scope.showAttTable = false;
  $scope.selectClassText = true;
  $scope.showDots = false;

  if($scope.day && self.selectedClass){
    $scope.showAttTable = true;
    $scope.selectClassText = false;
  }

  this.goToIndvClass = function(){
    if(self.selectedClass){
      $state.go('olr.mainfe.indvclass', {classRoomName: self.selectedClass.classRoomName, 
                                        subName:self.selectedClass.subjectName, 
                                        cId: self.selectedClass.classRoomId });
    }
  };

  this.getClassDetails = function(filledDatesArray){
    var formattedDate = moment($scope.day).format('YYYY-MM-DD');
      AttendanceService.getAttendanceDetails(self.selectedClass.classRoomId, self.selectedClass.subjectId, formattedDate).then(function(resp){
        console.log(resp.data);
        self.studentArray = resp.data.studentDetails;
        if(self.studentArray.length === 0){
          $scope.addStudentsMessage = true;
        }
        self.attendanceDate = resp.data.date.date;
        self.absenteesArray = resp.data.date.absentees;
        localStorageService.set('ia', resp.data.date.absentees);
        self.buildStudentArray(self.studentArray, self.absenteesArray, self.attendanceDate, self.allFilledDates);
      })
  };
  

  $scope.$watch('day', function() {
    $scope.showAttTable = true;
    self.getAllFilledDates();
  });

  // list of `state` value/display objects
  self.querySearch   = querySearch;
  self.selectedClassChange = selectedClassChange;
  self.searchTextChange   = searchTextChange;

  self.newClassRoom = newClassRoom;

  function newClassRoom(state) {
    alert("Sorry! You'll need to create a Class in Dashboard!");
  }

  function querySearch (query) {
    var results = query ? self.classRoomList.filter( createFilterFor(query) ) : self.classRoomList,
      deferred;
    if (self.simulateQuery) {
      deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    } 
    else {
      return results;
    }
  }

  function searchTextChange(text) {
    $log.info('Text changed to ' + text);
  }

  function selectedClassChange(item) {
    if(item){
      $scope.selectClassText = false;
      $scope.showTableSpinner = true;
      self.selectedClass = item;
      self.getAllFilledDates();
    }
    else{
      self.selectedClass = "";
      $scope.showAttTable = false;
      $scope.selectClassText = true;
      $scope.showDots = false;
      $scope.addStudentsMessage = false;
    }
    $log.info('Item changed to ' + JSON.stringify(item));
  }

  /**
   * Create filter function for a query string
   */
  function createFilterFor(query) {
    var lowercaseQuery = angular.lowercase(query);

    return function filterFn(classObj) {
      return (classObj.classRoomName.toLowerCase().indexOf(lowercaseQuery) === 0);
    };
  }


 //  $scope.classRoomList = [
 //    {'className':'Tenth-A1', 'id': 'Tenth-A1Id1'},
	// 	{'className':'Eigth-B2', 'id': 'Eigth-B2Id1'},
	// 	{'className':'SNE-1B', 'id': 'SNE-1BId1'},
	// 	{'className':'Seventh-alpha', 'id': 'Seventh-alphaId1'},
	// 	{'className':'JRE-2N', 'id': 'JRE-2NId1'}
	// ];



  self.classRoomName = self.selectedClass;

  var cols =[{'colDisplayName': ''},{'colDisplayName': 'Student Name'},{'colDisplayName': 'Email ID'}];

  // self.attendanceArray1 = {classRoomId: "seventh-1A", subjectId: "maths1", 
  //                         students: [{'studentName' : 'John Doe', 'studentId': 'john.doe@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 92}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 74}, {'examName': 'Exam4', 'marks': 94}, {'examName': 'Exam5', 'marks': 79}]},
  //                      {'studentName' : 'Mike Hamilton', 'studentId': 'mike.Hamilton@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 82}, {'examName': 'Exam2', 'marks': 94}, {'examName': 'Exam3', 'marks': 28}, {'examName': 'Exam4', 'marks': 58}, {'examName': 'Exam5', 'marks': 49}]},
  //                      {'studentName' : 'George Aldo', 'studentId': 'george.aldo@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 33}, {'examName': 'Exam2', 'marks': 84}, {'examName': 'Exam3', 'marks': 82}, {'examName': 'Exam4', 'marks': 68}, {'examName': 'Exam5', 'marks': 90}]},
  //                      {'studentName' : 'Ami Jackson', 'studentId': 'ami.jackson@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 72}, {'examName': 'Exam2', 'marks': 95}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 40}, {'examName': 'Exam5', 'marks': 87}]},
  //                      {'studentName' : 'Sai Sridhar Dasari', 'studentId': 'sai.sridhardasari@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 85}, {'examName': 'Exam2', 'marks': 78}, {'examName': 'Exam3', 'marks': 49}, {'examName': 'Exam4', 'marks': 39}, {'examName': 'Exam5', 'marks': 99}]},
  //                      {'studentName' : 'Chris McDonalds', 'studentId': 'chris.mcdonals@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 44}, {'examName': 'Exam2', 'marks': 73}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 93}, {'examName': 'Exam5', 'marks': 88}]},
  //                      {'studentName' : 'Kevin Peterson', 'studentId': 'kevin.peterson@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 0}, {'examName': 'Exam2', 'marks': 83}, {'examName': 'Exam3', 'marks': 34}, {'examName': 'Exam4', 'marks': 92}, {'examName': 'Exam5', 'marks': 79}]},
  //                      {'studentName' : 'Ricky Pointing', 'studentId': 'ricky.pointing@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 28}, {'examName': 'Exam2', 'marks': 97}, {'examName': 'Exam3', 'marks': 39}, {'examName': 'Exam4', 'marks': 18}, {'examName': 'Exam5', 'marks': 80}]},
  //                      {'studentName' : 'Adam Gilchrist', 'studentId': 'adam.dilly@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 49}, {'examName': 'Exam2', 'marks': 99}, {'examName': 'Exam3', 'marks': 47}, {'examName': 'Exam4', 'marks': 58}, {'examName': 'Exam5', 'marks': 86}]},
  //                      {'studentName' : 'Christian Ronaldino', 'studentId': 'christian.ronaldino@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 100}, {'examName': 'Exam2', 'marks': 84}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 78}, {'examName': 'Exam5', 'marks': 74}]},
  //                      {'studentName' : 'Stone Cold', 'studentId': 'stone.cold@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 39}, {'examName': 'Exam2', 'marks': 88}, {'examName': 'Exam3', 'marks': 77}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 71}]},
  //                      {'studentName' : 'Mark Mikael', 'studentId': 'Mark Mikael.doe@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 42}, {'examName': 'Exam2', 'marks': 89}, {'examName': 'Exam3', 'marks': 55}, {'examName': 'Exam4', 'marks': 48}, {'examName': 'Exam5', 'marks': 81}]},
  //                      {'studentName' : 'Sai Sridhar Mullapudi', 'studentId': 'saisridhar.mullapudi@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 82}, {'examName': 'Exam2', 'marks': 74}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 38}, {'examName': 'Exam5', 'marks': 43}]},
  //                      {'studentName' : 'Mark Zuckerburg', 'studentId': 'mark.zuckerburg@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 32}, {'examName': 'Exam2', 'marks': 85}, {'examName': 'Exam3', 'marks': 93}, {'examName': 'Exam4', 'marks': 100}, {'examName': 'Exam5', 'marks': 86}]},
  //                      {'studentName' : 'Jesica Andrew', 'studentId': 'jesica.andrew@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 56}, {'examName': 'Exam2', 'marks': 10}, {'examName': 'Exam3', 'marks': 45}, {'examName': 'Exam4', 'marks': 100}, {'examName': 'Exam5', 'marks': 19}]},
  //                      {'studentName' : 'Deepak Chandu Mokkapati', 'studentId': 'deepakchandu.mokkapati@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 92}, {'examName': 'Exam2', 'marks': 73}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 40}]},
  //                      {'studentName' : 'Christopher M', 'studentId': 'christopher.m@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 40}, {'examName': 'Exam2', 'marks': 94}, {'examName': 'Exam3', 'marks': 100}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 50}]},
  //                      {'studentName' : 'Bizmark Peterson', 'studentId': 'bizmark.peterson@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 72}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 94}, {'examName': 'Exam4', 'marks': 38}, {'examName': 'Exam5', 'marks': 70}]},
  //                      {'studentName' : 'David Drewpaul', 'studentId': 'david.Drewpaul@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 62}, {'examName': 'Exam2', 'marks': 88}, {'examName': 'Exam3', 'marks': 10}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 50}]},
  //                      {'studentName' : 'Kelly Johnson', 'studentId': 'kelly.johnson@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 90}, {'examName': 'Exam2', 'marks': 99}, {'examName': 'Exam3', 'marks': 90}, {'examName': 'Exam4', 'marks': 33}, {'examName': 'Exam5', 'marks': 93}]},
  //                      {'studentName' : 'Deepika Gannamaneni', 'studentId': 'deepika.gannamaneni@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 92}, {'examName': 'Exam2', 'marks': 100}, {'examName': 'Exam3', 'marks': 59}, {'examName': 'Exam4', 'marks': 67}, {'examName': 'Exam5', 'marks': 29}]},
  //                      {'studentName' : 'Chris Gayle', 'studentId': 'chris.gayle@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 23}, {'examName': 'Exam2', 'marks': 42}, {'examName': 'Exam3', 'marks': 94}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 85}]},
  //                      {'studentName' : 'Bravo Donald', 'studentId': 'bravo.donald@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 9}, {'examName': 'Exam2', 'marks': 92}, {'examName': 'Exam3', 'marks': 84}, {'examName': 'Exam4', 'marks': 87}, {'examName': 'Exam5', 'marks': 49}]},
  //                      {'studentName' : 'Captain America', 'studentId': 'captain.america@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 39}, {'examName': 'Exam2', 'marks': 100}, {'examName': 'Exam3', 'marks': 39}, {'examName': 'Exam4', 'marks': 39}, {'examName': 'Exam5', 'marks': 90}]},
  //                      {'studentName' : 'Bernard Hunk', 'studentId': 'bernard.hunk@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 69}, {'examName': 'Exam2', 'marks': 42}, {'examName': 'Exam3', 'marks': 58}, {'examName': 'Exam4', 'marks': 55}, {'examName': 'Exam5', 'marks': 83}]},
  //                      {'studentName' : 'Glen wood', 'studentId': 'glen.wood@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 28}, {'examName': 'Exam2', 'marks': 95}, {'examName': 'Exam3', 'marks': 97}, {'examName': 'Exam4', 'marks': 94}, {'examName': 'Exam5', 'marks': 91}]},
  //                      {'studentName' : 'Brian Saknovsky', 'studentId': 'brian.saknovsky@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 45}, {'examName': 'Exam2', 'marks': 52}, {'examName': 'Exam3', 'marks': 37}, {'examName': 'Exam4', 'marks': 73}, {'examName': 'Exam5', 'marks': 100}]},
  //                      {'studentName' : 'Allen Peter', 'studentId': 'allen.peter@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 66}, {'examName': 'Exam2', 'marks': 49}, {'examName': 'Exam3', 'marks': 83}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 100}]},
  //                      {'studentName' : 'John Doe 2', 'studentId': 'john.doe2@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 99}, {'examName': 'Exam2', 'marks': 39}, {'examName': 'Exam3', 'marks': 23}, {'examName': 'Exam4', 'marks': 99}, {'examName': 'Exam5', 'marks': 94}]},
  //                      {'studentName' : 'Koushik Yenugula', 'studentId': 'koushik.yenugula@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 86}, {'examName': 'Exam2', 'marks': 19}, {'examName': 'Exam3', 'marks': 0}, {'examName': 'Exam4', 'marks': 95}, {'examName': 'Exam5', 'marks': 34}]},
  //                      {'studentName' : 'Prince portor', 'studentId': 'prince.portor@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 21}, {'examName': 'Exam2', 'marks': 46}, {'examName': 'Exam3', 'marks': 44}, {'examName': 'Exam4', 'marks': 97}, {'examName': 'Exam5', 'marks': 2}]},
  //                      {'studentName' : 'Jack Lauremen', 'studentId': 'jack.lauremen@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 2}, {'examName': 'Exam2', 'marks': 85}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 29}, {'examName': 'Exam5', 'marks': 93}]},
  //                      {'studentName' : 'Barack Obama', 'studentId': 'barack.obama@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 67}, {'examName': 'Exam2', 'marks': 90}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 44}, {'examName': 'Exam5', 'marks': 81}]},
  //                      {'studentName' : 'John F Kennedy', 'studentId': 'john.kennedy@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 46}, {'examName': 'Exam2', 'marks': 52}, {'examName': 'Exam3', 'marks': 44}, {'examName': 'Exam4', 'marks': 66}, {'examName': 'Exam5', 'marks': 86}]},
  //                      {'studentName' : 'Alexander Vanter', 'studentId': 'alexander.vanter@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 38}, {'examName': 'Exam2', 'marks': 99}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 82}, {'examName': 'Exam5', 'marks': 46}]},
  //                      {'studentName' : 'Abraham Lincoln', 'studentId': 'abraham.lincoln@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 39}, {'examName': 'Exam2', 'marks': 100}, {'examName': 'Exam3', 'marks': 47}, {'examName': 'Exam4', 'marks': 20}, {'examName': 'Exam5', 'marks': 90}]},
  //                      {'studentName' : 'Steve Jobs', 'studentId': 'steve.jobs@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 92}, {'examName': 'Exam2', 'marks': 49}, {'examName': 'Exam3', 'marks': 48}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 83}]},
  //                      {'studentName' : 'Lisa fernendez', 'studentId': 'lisa.fernendez@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 40}, {'examName': 'Exam2', 'marks': 49}, {'examName': 'Exam3', 'marks': 93}, {'examName': 'Exam4', 'marks': 40}, {'examName': 'Exam5', 'marks': 99}]},
  //                      {'studentName' : 'Madona morney', 'studentId': 'madona.morney@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 20}, {'examName': 'Exam2', 'marks': 33}, {'examName': 'Exam3', 'marks': 39}, {'examName': 'Exam4', 'marks': 70}, {'examName': 'Exam5', 'marks': 91}]},
  //                      {'studentName' : 'Adolf Mitchel Doe', 'studentId': 'adolf.mitchel@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 30}, {'examName': 'Exam2', 'marks': 19}, {'examName': 'Exam3', 'marks': 22}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 44}]},
  //                      {'studentName' : 'George Goula', 'studentId': 'george.goula@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 50}, {'examName': 'Exam2', 'marks': 93}, {'examName': 'Exam3', 'marks': 94}, {'examName': 'Exam4', 'marks': 84}, {'examName': 'Exam5', 'marks': 94}]},
  //                      {'studentName' : 'John Grisham', 'studentId': 'john.grisham@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 44}, {'examName': 'Exam2', 'marks': 93}, {'examName': 'Exam3', 'marks': 59}, {'examName': 'Exam4', 'marks': 100}, {'examName': 'Exam5', 'marks': 93}]},
  //                      {'studentName' : 'Alex Mandervano', 'studentId': 'alex.mandervano@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 22}, {'examName': 'Exam2', 'marks': 97}, {'examName': 'Exam3', 'marks': 83}, {'examName': 'Exam4', 'marks': 44}, {'examName': 'Exam5', 'marks': 39}]},
  //                      {'studentName' : 'Eleanor Breslin', 'studentId': 'eleanor.breslin@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 3}, {'examName': 'Exam2', 'marks': 98}, {'examName': 'Exam3', 'marks': 82}, {'examName': 'Exam4', 'marks': 66}, {'examName': 'Exam5', 'marks': 100}]},
  //                      {'studentName' : 'Donald Trump', 'studentId': 'donald.trump@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 19}, {'examName': 'Exam2', 'marks': 0}, {'examName': 'Exam3', 'marks': 75}, {'examName': 'Exam4', 'marks': 93}, {'examName': 'Exam5', 'marks': 44}]},
  //                      {'studentName' : 'Shailendar Singh', 'studentId': 'shailendar.singh@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 43}, {'examName': 'Exam2', 'marks': 32}, {'examName': 'Exam3', 'marks': 85}, {'examName': 'Exam4', 'marks': 65}, {'examName': 'Exam5', 'marks': 99}]},
  //                      {'studentName' : 'Cris Cross G', 'studentId': 'criss.cross@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 44}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 44}, {'examName': 'Exam5', 'marks': 48}]},
  //                      {'studentName' : 'Margaret Miner', 'studentId': 'margaret.minar@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 67}, {'examName': 'Exam2', 'marks': 99}, {'examName': 'Exam3', 'marks': 93}, {'examName': 'Exam4', 'marks': 66}, {'examName': 'Exam5', 'marks': 73}]},
  //                      {'studentName' : 'Nick Noel', 'studentId': 'nick.noel@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 71}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 99}, {'examName': 'Exam4', 'marks': 22}, {'examName': 'Exam5', 'marks': 46}]},
  //                      {'studentName' : 'Zuang Chao', 'studentId': 'zuang.chao@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 0}, {'examName': 'Exam2', 'marks': 4}, {'examName': 'Exam3', 'marks': 41}, {'examName': 'Exam4', 'marks': 58}, {'examName': 'Exam5', 'marks': 39}]},
  //                      {'studentName' : 'ling ling', 'studentId': 'ling.ling@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 17}, {'examName': 'Exam2', 'marks': 19}, {'examName': 'Exam3', 'marks': 71}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 3}]},
  //                      {'studentName' : 'Melissa Mathews', 'studentId': 'melissa.mathews@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 58}, {'examName': 'Exam2', 'marks': 44}, {'examName': 'Exam3', 'marks': 97}, {'examName': 'Exam4', 'marks': 78}, {'examName': 'Exam5', 'marks': 10}]},
  //                      {'studentName' : 'Laura Kaplan', 'studentId': 'laura.kaplan@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 23}, {'examName': 'Exam2', 'marks': 33}, {'examName': 'Exam3', 'marks': 29}, {'examName': 'Exam4', 'marks': 75}, {'examName': 'Exam5', 'marks': 34}]},
  //                      {'studentName' : 'Samuel Sammy Adams', 'studentId': 'samuel.s.adams@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 12}, {'examName': 'Exam2', 'marks': 16}, {'examName': 'Exam3', 'marks': 47}, {'examName': 'Exam4', 'marks': 80}, {'examName': 'Exam5', 'marks': 48}]},
  //                      {'studentName' : 'Dinesh Reddy Julakanti', 'studentId': 'dineshreddy.julkanti@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 99}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 50}]},
  //                      {'studentName' : 'Moore John Doe', 'studentId': 'moore.j.doe@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 49}, {'examName': 'Exam2', 'marks': 55}, {'examName': 'Exam3', 'marks': 49}, {'examName': 'Exam4', 'marks':36}, {'examName': 'Exam5', 'marks': 61}]},
  //                      {'studentName' : 'Hillary Clinton', 'studentId': 'hillary.clinton@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 100}, {'examName': 'Exam2', 'marks': 39}, {'examName': 'Exam3', 'marks': 58}, {'examName': 'Exam4', 'marks': 35}, {'examName': 'Exam5', 'marks': 36}]},
  //                      {'studentName' : 'Bill Gates', 'studentId': 'bill.gates@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 10}, {'examName': 'Exam2', 'marks': 33}, {'examName': 'Exam3', 'marks': 88}, {'examName': 'Exam4', 'marks': 63}, {'examName': 'Exam5', 'marks': 78}]},
  //                      {'studentName' : 'John mitchell', 'studentId': 'john.mitchell@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 59}, {'examName': 'Exam2', 'marks': 57}, {'examName': 'Exam3', 'marks': 58}, {'examName': 'Exam4', 'marks': 38}, {'examName': 'Exam5', 'marks': 53}]},
  //                      {'studentName' : 'Ajinkya Sangakkara', 'studentId': 'ajinkya.sangakkara@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 59}, {'examName': 'Exam2', 'marks': 76}, {'examName': 'Exam3', 'marks': 93}, {'examName': 'Exam4', 'marks': 49}, {'examName': 'Exam5', 'marks': 84}]}
  //                       ],
  //                         dates: [{date: '2016-09-10', absentees: [{'studentName': 'Deepak', 'studentId': 'dpak@gmail.com'}]}]};

  // self.studentArray = self.attendanceArray1.students;
  // self.attendanceDate = self.attendanceArray1.dates[0].date;
  // self.absenteesArray = self.attendanceArray1.dates[0].absentees;
  // self.allFilledDates = ['2016-09-09,2016-09-08'];

  var addToAbsenteesArray = function(item){
    self.absenteesArray.push({'studentName': item.studentName, 'studentId': item.studentId});
  };

  var deleteFromAbsenteesArray = function(item){
    var index = R.findIndex(R.propEq('studentId', item.studentId))(self.absenteesArray);
    if(index > -1){
      self.absenteesArray.splice(index, 1);
    }
  };

  this.getAllFilledDates = function(){
    if(self.selectedClass){
      AttendanceService.getAllDates(self.selectedClass.classRoomId, self.selectedClass.subjectId).then(function(resp){
        $scope.calFilledDates = resp.data[0].filledDates;
        self.allFilledDates = $scope.calFilledDates;
        $scope.showDots = true;
        $scope.showAttTable = true;
        $scope.selectClassText = false;
        self.getClassDetails(resp.data);
      });
    }
    else{
      return;
    }   
  };

  self.getAllFilledDates();

  this.buildStudentArray = function(studentArray, absenteesArray, attendanceDate, allFilledDates){
    $scope.totalItems =[];
    var isDisabled = false;
    if(!(R.contains(attendanceDate, allFilledDates))){
      isDisabled = true;
    }
    for(var i=0; i<studentArray.length; i++){
      var item = {'studentName': studentArray[i].studentName, 'studentId': studentArray[i].studentId, 'isDisabled': isDisabled};
      if(R.findIndex(R.propEq('studentName', studentArray[i].studentName))(absenteesArray) > -1){
        item.isPresent = 0;
      }
      else{
        item.isPresent = 1;
      }
      if(isDisabled){
        item.isPresent = 'disable';
      }
      $scope.totalItems.push(item);
    };
    $scope.showTableSpinner = false;
  };

  //self.buildStudentArray(self.studentArray, self.absenteesArray, self.attendanceDate, self.allFilledDates);

  this.showTick = function(item){
    if(item.isDisabled){
      return false;
    }
    else{
      if(item.isPresent === 1){
        return true;
      }
      else{
        return false;
      }
    }
  };

  this.showCross = function(item){
    if(item.isDisabled){
      return false;
    }
    else{
      if(item.isPresent === 0){
        return true;
      }
      else{
        return false;
      }
    }
  };

  this.clickOnAdd = function(item){
    item.isDisabled = false;
    item.isPresent = 1;
  }

  this.toggleAttendance = function(item, status){
    $scope.sortType     = 'studentName';
    if(status == 'absent'){
      addToAbsenteesArray(item);
      item.isPresent = 0;
    }
    else if(status == 'present'){
      deleteFromAbsenteesArray(item);
      item.isPresent = 1;
    } 
  };

  // self.absentStudents = [{'studentName': 'Yenugudhati veera venkata sri sai phani harsha', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}];

  // self.attendanceArray = [{'studentName': 'Yenugudhati veera venkata sri sai phani harsha', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': false}]},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'dateList' : [{'date':'08/20/2016', 'isPresent': true}]}
  //            ];



  // self.studentArray= [{'studentName': 'Sai SS', 'studentId': 'sai@gmail.com', 'Exam1' : 92, 'Exam2': 95}, 
  //            {'studentName': 'Deepak', 'studentId': 'dpak@gmail.com', 'Exam1' : 99, 'Exam2': 91},
  //            {'studentName': 'Sharath', 'studentId': 'sharath@gmail.com', 'Exam1' : 82, 'Exam2': 86},
  //            {'studentName': 'Dinesh', 'studentId': 'dinesh@gmail.com', 'Exam1' : 72, 'Exam2': 54}];

  // var localStudentArray = self.studentArray;

  // self.examsArray = [];

  // var studArrayKeys = [];
  // for(var key in localStudentArray[0]){
  //   studArrayKeys.push(key);
  // }
  // studArrayKeys.splice(0, 2);
   
  // for(var i=0;i<studArrayKeys.length;i++){
  //   self.examsArray.push(GetService.getExamObjByName(studArrayKeys[i]));
  // }

  $scope.sortType     = 'studentName'; // set the default sort type
  $scope.sortReverse  = false;  // set the default sort order
  $scope.searchClass   = '';     // set the default search/filter term
  
  // create the list of Class Rooms(dummy)
  // $scope.classObj = [
  //   { classRoomName: 'Tenth-A1', subject: 'Mathematics', strength: 42 },
  //   { classRoomName: 'Eigth-B2', subject: 'English', strength: 54 },
  //   { classRoomName: 'SNE-1B', subject: 'Chemistry', strength: 37 },
  //   { classRoomName: 'Seventh-alpha', subject: 'Social', strength: 56 }
  // ];

  // $scope.editItem = function (parentIndex, index) {
  //   $scope.editing = ""+parentIndex+index;
  //   self.attendanceArray[parentIndex].dateList[index].isPresent = false;
  //   console.log(self.attendanceArray);
  // };

  // $scope.doneEditing = function (parentIndex, index) {
  //   $scope.editing = ""+parentIndex;
  //   self.attendanceArray[parentIndex].dateList[index].isPresent = true;

  //   //dong some background ajax calling for persistence...
  //   console.log(self.attendanceArray);
  // };

  self.sortTableOnClick = function(param){
    $scope.sortType = param;
    $scope.sortReverse = !$scope.sortReverse;
  };





  $scope.selected = [];

  $scope.toggle = function (item, list) {
    $scope.sortType     = 'studentName';
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    }
    else {
      list.push(item);
    }
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.toggleAll = function (){
    if ($scope.selected.length === $scope.totalItems.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = $scope.totalItems.slice(0);
    }
  };

  $scope.isChecked = function() {
    return $scope.selected.length === $scope.totalItems.length;
  };

  self.markSelectedPresent = function(){
    for(var i=0; i<$scope.totalItems.length; i++){
      if(R.findIndex(R.propEq('studentId', $scope.totalItems[i].studentId))($scope.selected) > -1){
        $scope.totalItems[i].isDisabled = false;
        deleteFromAbsenteesArray($scope.totalItems[i]);
        $scope.totalItems[i].isPresent = 1;
      }
    }
    $scope.selected = [];
  };

  self.markSelectedAbsent = function(){
    for(var i=0; i<$scope.totalItems.length; i++){
      if(R.findIndex(R.propEq('studentId', $scope.totalItems[i].studentId))($scope.selected) > -1){
        $scope.totalItems[i].isDisabled = false;
        addToAbsenteesArray($scope.totalItems[i]);
        $scope.totalItems[i].isPresent = 0;
      }
    }
    $scope.selected = [];
  };

  $scope.selectClassText = true;
  $scope.showAttTable = false;

  if(self.selectedClass){
    $scope.showAttTable = true;
    $scope.selectClassText = false;
  }

  self.save = function(){
    for(var i=0; i<$scope.totalItems.length; i++){
      if($scope.totalItems[i].isDisabled){
        $scope.showAttendanceErr = true;
        return;
      }
    }
    $scope.showAttendanceErr = false;
    var attendanceObj = {"classRoomId": self.selectedClass.classRoomId, "subjectId": self.selectedClass.subjectId, "subjectName":self.selectedClass.subjectName} ;
    var dates= [];
    self.initialAbsentees = localStorageService.get('ia');
    dates.push({"date": self.attendanceDate, "absentees": []});

    if(self.initialAbsentees.length < self.absenteesArray.length){
      var pushArray = R.difference(R.pluck('studentId')(self.absenteesArray), R.pluck('studentId')(self.initialAbsentees));
      for(var j=0; j<pushArray.length; j++){
        var pushItem = R.find(R.propEq('studentId', pushArray[j]))(self.absenteesArray);
        if(pushItem){
          dates[0].absentees.push(pushItem);
        }
      }
    }
    attendanceObj.dates = dates;
    if(self.initialAbsentees.length > self.absenteesArray.length){
      attendanceObj.mislens = [];
      attendanceObj.mislens.push({"date": self.attendanceDate, "details":[]});
      var pullArray = R.difference(R.pluck('studentId')(self.initialAbsentees), R.pluck('studentId')(self.absenteesArray));
      for(var k=0; k<pullArray.length; k++){
        var pullItem = R.find(R.propEq('studentId', pullArray[k]))(self.initialAbsentees);
        if(pullItem){
          attendanceObj.mislens[0].details.push(pullItem);
        }
      }
      //attendanceObj.mislens.push({"date": self.attendanceDate, "details":pullArray});
    }
    AttendanceService.saveAttendance(attendanceObj).then(function(resp){
      if(resp.data.updated){
        showToast();
      }
      self.getAllFilledDates();
    });
    //console.log($scope.totalItems);
  };

}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-attendance/AttendanceController.js
 **/